// Platform roles — accounts that operate the software rather than belonging to
// a customer's workspace. Mirrors backend/src/utils/roles.js.
//
//   owner      — the business view: sales, packages per company, headcount
//   superadmin — the engineering view: everything the owner sees, plus system
//                health, database and diagnostics
//
// Both carry no tenant, so every tenant-scoped API call returns 403 for them.
// They belong in the platform panel at /superadmin, not the CRM.

export const PLATFORM_ROLES = ['superadmin', 'owner']

export function isPlatformRole(role) {
  return PLATFORM_ROLES.includes(role)
}

export const ROLE_LABEL = {
  superadmin: 'Super Admin',
  owner:      'Owner',
  admin:      'Admin',
  technician: 'Technician',
  staff:      'Staff',
}

// Panel pages each role may open. The owner runs the business; the engineering
// views (system health) and the churn model are the superadmin's.
const OWNER_HIDDEN = ['health', 'churn']

export function canSeePanelPage(role, pageId) {
  if (role === 'superadmin') return true
  if (role === 'owner') return !OWNER_HIDDEN.includes(pageId)
  return false
}
